   $(function() {
        $(".dial").knob({
            format : function (value) {
                return value + '%';
            }
        }); 
        $('.tab-content>.tab-pane:first-child').addClass('active show');
    });
